import { RoleCategory } from './types';

export const ROLES_PATH = '/diam/roles';

export const ROLE_CATEGORY_QUERY_PARAMETER = 'tab';

export const EMPTY_TEAM_NAME = '—';

export const DEFAULT_EXPANDED_PERMISSION_IDS = [
  'gapi-administration',
  'role-3',
  'role-4',
  'role-5',
];

export function getRoleDetailsPath(
  roleCategory: RoleCategory,
  roleId: string,
): string {
  return `${ROLES_PATH}/${roleCategory}/${roleId}`;
}

export function getRolesListPath(roleCategory: RoleCategory): string {
  return `${ROLES_PATH}?${ROLE_CATEGORY_QUERY_PARAMETER}=${roleCategory}`;
}
